import * as Mod1 from "./discourse/boards-route-map";
import * as Mod2 from "./discourse/components/auto-linked-text";
import * as Mod3 from "./discourse/components/boards-access-control-field";
import * as Mod4 from "./discourse/components/boards-add-from-topic-column-submenu";
import * as Mod5 from "./discourse/components/boards-add-from-topic-menu";
import * as Mod6 from "./discourse/components/boards-board-viewer";
import * as Mod7 from "./discourse/components/boards-card";
import * as Mod8 from "./discourse/components/boards-column";
import * as Mod9 from "./discourse/components/boards-editable-title";
import * as Mod10 from "./discourse/components/boards-menu";
import * as Mod11 from "./discourse/components/boards-page";
import * as Mod12 from "./discourse/components/modal/boards-add-topic-as-card";
import * as Mod13 from "./discourse/components/modal/boards-archive";
import * as Mod14 from "./discourse/components/modal/boards-board-settings";
import * as Mod15 from "./discourse/components/modal/boards-card-detail";
import * as Mod16 from "./discourse/components/modal/boards-column-settings";
import * as Mod17 from "./discourse/components/modal/boards-constraint-fix";
import * as Mod18 from "./discourse/components/modal/boards-floater-assign";
import * as Mod19 from "./discourse/components/modal/boards-topic-card-detail";
import * as Mod20 from "./discourse/controllers/boards-board";
import * as Mod21 from "./discourse/initializers/boards-add-from-topic-button";
import * as Mod22 from "./discourse/initializers/boards-admin-plugin-configuration-nav";
import * as Mod23 from "./discourse/initializers/boards-keyboard-shortcuts";
import * as Mod24 from "./discourse/initializers/boards-onebox-relative-dates";
import * as Mod25 from "./discourse/initializers/boards-topic-pill";
import * as Mod26 from "./discourse/lib/boards-access-control";
import * as Mod27 from "./discourse/lib/boards-auto-scroll";
import * as Mod28 from "./discourse/lib/boards-card-ordering";
import * as Mod29 from "./discourse/lib/boards-categories";
import * as Mod30 from "./discourse/lib/boards-column-helpers";
import * as Mod31 from "./discourse/lib/boards-motion";
import * as Mod32 from "./discourse/lib/boards-topic-pill";
import * as Mod33 from "./discourse/lib/boards-urls";
import * as Mod34 from "./discourse/lib/fabricators";
import * as Mod35 from "./discourse/models/board";
import * as Mod36 from "./discourse/models/card";
import * as Mod37 from "./discourse/models/column";
import * as Mod38 from "./discourse/routes/boards-board-card";
import * as Mod39 from "./discourse/routes/boards-board-configure";
import * as Mod40 from "./discourse/routes/boards-board";
import * as Mod41 from "./discourse/routes/boards";
import * as Mod42 from "./discourse/templates/boards-board-card";
import * as Mod43 from "./discourse/templates/boards-board-configure";
import * as Mod44 from "./discourse/templates/boards-board";
import * as Mod45 from "./discourse/templates/boards";
const compatModules = {
  "discourse/boards-route-map": Mod1,
  "discourse/components/auto-linked-text": Mod2,
  "discourse/components/boards-access-control-field": Mod3,
  "discourse/components/boards-add-from-topic-column-submenu": Mod4,
  "discourse/components/boards-add-from-topic-menu": Mod5,
  "discourse/components/boards-board-viewer": Mod6,
  "discourse/components/boards-card": Mod7,
  "discourse/components/boards-column": Mod8,
  "discourse/components/boards-editable-title": Mod9,
  "discourse/components/boards-menu": Mod10,
  "discourse/components/boards-page": Mod11,
  "discourse/components/modal/boards-add-topic-as-card": Mod12,
  "discourse/components/modal/boards-archive": Mod13,
  "discourse/components/modal/boards-board-settings": Mod14,
  "discourse/components/modal/boards-card-detail": Mod15,
  "discourse/components/modal/boards-column-settings": Mod16,
  "discourse/components/modal/boards-constraint-fix": Mod17,
  "discourse/components/modal/boards-floater-assign": Mod18,
  "discourse/components/modal/boards-topic-card-detail": Mod19,
  "discourse/controllers/boards-board": Mod20,
  "discourse/initializers/boards-add-from-topic-button": Mod21,
  "discourse/initializers/boards-admin-plugin-configuration-nav": Mod22,
  "discourse/initializers/boards-keyboard-shortcuts": Mod23,
  "discourse/initializers/boards-onebox-relative-dates": Mod24,
  "discourse/initializers/boards-topic-pill": Mod25,
  "discourse/lib/boards-access-control": Mod26,
  "discourse/lib/boards-auto-scroll": Mod27,
  "discourse/lib/boards-card-ordering": Mod28,
  "discourse/lib/boards-categories": Mod29,
  "discourse/lib/boards-column-helpers": Mod30,
  "discourse/lib/boards-motion": Mod31,
  "discourse/lib/boards-topic-pill": Mod32,
  "discourse/lib/boards-urls": Mod33,
  "discourse/lib/fabricators": Mod34,
  "discourse/models/board": Mod35,
  "discourse/models/card": Mod36,
  "discourse/models/column": Mod37,
  "discourse/routes/boards-board-card": Mod38,
  "discourse/routes/boards-board-configure": Mod39,
  "discourse/routes/boards-board": Mod40,
  "discourse/routes/boards": Mod41,
  "discourse/templates/boards-board-card": Mod42,
  "discourse/templates/boards-board-configure": Mod43,
  "discourse/templates/boards-board": Mod44,
  "discourse/templates/boards": Mod45,
};
export { compatModules };
export default compatModules;
